import { clearCurrentUserCache, getUserData } from 'app/actions/UserData';

export default function headerCommonMapDispatchToProps(dispatch) {
  return {
    getUserData: params => dispatch(getUserData(params)),
    onLogout: () => {
      clearCurrentUserCache();
    },
  };
}
